import styled from "styled-components";

const AboutDefaultBox = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: ${({theme}) => theme.font.family.body};
  padding-top: 3rem;
  
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-top: 0;
  }
`;

export const AboutBox = AboutDefaultBox;